import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoBanksGetReq } from "./abst/DtoBanksGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoBanksGetReqImple extends DtoBanksGetReq {
  //口座マスタ一覧の検索条件
  public bankName: string | null = null;
  public branchName: string | null = null;
  public bankNumber: string | null = null;
  public bankType: number | null = null;

  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
